module.exports = __webpack_public_path__ + "img/icon-en-construction.3d2860c9.png";